/* ============================================================
   Mapa de tiendas Jousfit — lógica interactiva
   Depende de:  window.MX_MAP   (assets/mx-dots.js)
                window.JOUSFIT_TIENDAS (assets/tiendas.js)
   Sin librerías externas.

   Interacción por ESTADO: al seleccionar una tienda, la cámara hace
   zoom de enfoque hacia los dots de su estado, el estado se enciende
   en rosa y aparecen ahí los puntos de venta. Botón para volver a
   la vista de todo México.
   ============================================================ */
(function () {
  "use strict";

  var SVGNS = "http://www.w3.org/2000/svg";
  var MAP = window.MX_MAP;
  var TIENDAS = (window.JOUSFIT_TIENDAS || []).filter(function (t) {
    return typeof t.lat === "number" && typeof t.lng === "number";
  });

  var root = document.querySelector("[data-jf-locator]");
  if (!root) return;
  if (!MAP) { console.error("[mapa-tiendas] falta MX_MAP (assets/mx-dots.js)"); return; }

  // Textos de la UI que arma el JS. Llegan como data-* desde la sección para que sean
  // settings del tema y, por lo tanto, TRADUCIBLES (Shopify solo traduce lo que está
  // escrito en el JSON de la plantilla). Los defaults dejan funcionando el index.html
  // de preview, que no tiene Liquid.
  var T = {
    back: root.getAttribute("data-i18n-back") || "Ver todo México",
    close: root.getAttribute("data-i18n-close") || "Cerrar",
    directions: root.getAttribute("data-i18n-directions") || "Cómo llegar",
    empty: root.getAttribute("data-i18n-empty") || "Todavía no hay tiendas cargadas.",
    mapLabel: root.getAttribute("data-i18n-map-label") || "Mapa de México con las tiendas Jousfit",
    filterAll: root.getAttribute("data-i18n-filter-all") || "Todas",
    typeStore: root.getAttribute("data-i18n-type-store") || "Tiendas",
    typeDist: root.getAttribute("data-i18n-type-dist") || "Distribuidoras",
    typeStoreOne: root.getAttribute("data-i18n-type-store-one") || "Tienda",
    typeDistOne: root.getAttribute("data-i18n-type-dist-one") || "Distribuidora",
  };

  // ---------- Tipo de punto: tienda (default) o distribuidora ----------
  // El default hace que los datos viejos —sin `tipo`— sigan siendo tiendas.
  var DIST = "distribuidora";
  function tipoOf(t) { return normStr(t.tipo) === DIST ? DIST : "tienda"; }
  function esDist(t) { return tipoOf(t) === DIST; }
  // "zona" = no publicamos su domicilio exacto (ver nota de privacidad en tiendas.js)
  function esZona(t) { return normStr(t.precision) === "zona"; }

  var byId = {};
  TIENDAS.forEach(function (t) { byId[t.id] = t; });

  // Filtro por tipo: "todas" | "tienda" | "distribuidora". Filtra mapa y listado a la vez.
  var activeType = "todas";
  function pasaFiltro(t) { return activeType === "todas" || tipoOf(t) === activeType; }
  function idVisible(id) { var t = byId[id]; return !t || pasaFiltro(t); }

  // ---------- Agrupación por CIUDAD ----------
  // Cuando una ciudad junta muchos puntos NO se abren en abanico: se dibuja UNA
  // burbuja con el número. El abanico tiene radio 20+7n —crece sin tope— y medido:
  // a 10 puntos empieza a aventar pins FUERA del estado y a 40 se salen los 40.
  // Y de fondo: la rejilla de dots NO tiene resolución para distinguir puntos dentro
  // de una misma ciudad (todos caen en el mismo dot), así que separarlos era
  // precisión inventada. Por debajo del umbral se conserva el abanico, que ahí sí
  // funciona (medido: 0 pins fuera del estado, 68px de separación).
  var CLUSTER_MIN = 5;
  var clusterEls = {};   // cityKey -> {el, city}
  var cityOf = {};       // storeId -> ciudad
  var bucketOf = {};     // storeId -> grupo (ciudad + tipo) que puede volverse burbuja
  var cityEls = {};      // cityKey -> {el, head, city}  (listado)
  var openCityKey = null;

  // ¿lo representa una burbuja? Entonces el pin suelto no se dibuja.
  function enBurbuja(id) { var b = bucketOf[id]; return !!(b && clusterEls[b.key]); }
  // El filtro NO esconde en el mapa: apaga a gris. Así el mapa no se vacía al filtrar
  // y se sigue viendo que en ese estado hay más puntos del otro tipo.
  function pinVisible(id) { return !enBurbuja(id); }
  function apagado(id) { return !idVisible(id); }
  function tipoActivo(tipo) { return activeType === "todas" || tipo === activeType; }

  var proj = MAP.proj, vb = MAP.viewBox;
  var W = vb.w, H = vb.h, ASPECT = W / H;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // Sheet (bottom-sheet) en teléfonos y en horizontal de pantalla baja. Debe
  // coincidir con el @media del CSS.
  var mqMobile = window.matchMedia("(max-width: 640px), (max-width: 1024px) and (max-height: 480px)");

  // Proyección idéntica a build/gen_dots.py -> los pins caen sobre la silueta
  function px(lon) { return proj.pad + (lon - proj.lonMin) * proj.k * proj.scale; }
  function py(lat) { return proj.pad + (proj.latMax - lat) * proj.scale; }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function digits(s) { return String(s || "").replace(/[^\d]/g, ""); }
  function mapsUrl(t) {
    if (t.maps) return t.maps;
    // Con `precision: "zona"` NO damos ruta a la puerta: buscamos la colonia/ciudad.
    // Es lo que permite mostrar a una distribuidora sin publicar su domicilio.
    if (esZona(t)) {
      var q = [t.direccion, t.ciudad, t.estado].filter(Boolean).join(", ");
      return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(q);
    }
    return "https://www.google.com/maps/dir/?api=1&destination=" + t.lat + "," + t.lng;
  }
  // Matching de estado tolerante: ignora acentos/mayúsculas/espacios y acepta alias
  // comunes (CDMX, Edomex, etc.). Así el campo `estado` no tiene que ser exacto.
  function normStr(s) {
    return String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "")
      .toLowerCase().replace(/\s+/g, " ").trim();
  }
  var STATE_INDEX = {};
  proj.states.forEach(function (name, i) { STATE_INDEX[normStr(name)] = i; });
  var STATE_ALIAS = {
    "cdmx": "Ciudad de México", "df": "Ciudad de México", "d.f.": "Ciudad de México",
    "distrito federal": "Ciudad de México",
    "edomex": "México", "estado de mexico": "México", "edo de mexico": "México",
    "edo. de mexico": "México",
    "coahuila de zaragoza": "Coahuila", "michoacan de ocampo": "Michoacán",
    "veracruz de ignacio de la llave": "Veracruz"
  };
  function stateIdxOf(t) {
    var key = normStr(t.estado);
    if (STATE_ALIAS[key]) key = normStr(STATE_ALIAS[key]);
    var idx = STATE_INDEX[key];
    return idx === undefined ? -1 : idx;
  }

  // ---------- Iconos (inline SVG) ----------
  var IC = {
    phone: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
    wa: '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M17.47 14.38c-.3-.15-1.74-.86-2-.96-.27-.1-.47-.15-.66.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.66-1.6-.9-2.18-.24-.57-.48-.5-.66-.5l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.87 1.22 3.07.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.74-.71 1.98-1.4.24-.68.24-1.27.17-1.4-.07-.12-.27-.19-.57-.34zM12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"/></svg>',
    route: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    pin: '<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z"/></svg>',
    back: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>',
    chev: '<svg class="jf-side__chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>'
  };

  // ---------- SVG del mapa ----------
  var mapWrap = root.querySelector(".jf-map-wrap");
  var stage = root.querySelector("[data-map-stage]");
  stage.style.aspectRatio = W + " / " + H;

  var svg = document.createElementNS(SVGNS, "svg");
  svg.setAttribute("viewBox", "0 0 " + W + " " + H);
  svg.setAttribute("class", "jf-map-svg");
  svg.setAttribute("role", "img");
  svg.setAttribute("aria-label", T.mapLabel);

  // Centroide + distancia máx (para el reveal en onda radial)
  var cxC = 0, cyC = 0, n = MAP.dots.length;
  for (var a = 0; a < n; a++) { cxC += MAP.dots[a][0]; cyC += MAP.dots[a][1]; }
  cxC /= n; cyC /= n;
  var maxDist = 1;
  for (var b = 0; b < n; b++) {
    var dd = Math.hypot(MAP.dots[b][0] - cxC, MAP.dots[b][1] - cyC);
    if (dd > maxDist) maxDist = dd;
  }

  // Capa de puntos (silueta) + agrupación por estado + bbox por estado
  var gDots = document.createElementNS(SVGNS, "g");
  var frag = document.createDocumentFragment();
  var dotsByState = {};
  var stateBBox = {};
  for (var i = 0; i < n; i++) {
    var d = MAP.dots[i], st = d[2];
    var c = document.createElementNS(SVGNS, "circle");
    var cls = "jf-dot" + (i % 29 === 0 ? " jf-dot--twinkle" : "");
    c.setAttribute("class", cls);
    c.setAttribute("cx", d[0]);
    c.setAttribute("cy", d[1]);
    c.setAttribute("r", "1.5");
    var dist = Math.hypot(d[0] - cxC, d[1] - cyC);
    c.style.setProperty("--d", Math.round(120 + (dist / maxDist) * 640) + "ms");
    if (i % 29 === 0) c.style.setProperty("--td", ((i % 50) / 10) + "s");
    frag.appendChild(c);
    (dotsByState[st] || (dotsByState[st] = [])).push(c);
    var bb = stateBBox[st] || (stateBBox[st] = { minx: 1e9, miny: 1e9, maxx: -1e9, maxy: -1e9 });
    if (d[0] < bb.minx) bb.minx = d[0];
    if (d[0] > bb.maxx) bb.maxx = d[0];
    if (d[1] < bb.miny) bb.miny = d[1];
    if (d[1] > bb.maxy) bb.maxy = d[1];
  }
  gDots.appendChild(frag);
  svg.appendChild(gDots);

  // Capa de conectores (líneas del abanico) debajo de los pins
  var gConnectors = document.createElementNS(SVGNS, "g");
  svg.appendChild(gConnectors);
  // Capa de pins
  var gPins = document.createElementNS(SVGNS, "g");
  svg.appendChild(gPins);
  stage.appendChild(svg);

  // Botón "Ver todo México"
  var back = document.createElement("button");
  back.type = "button";
  back.className = "jf-back";
  back.innerHTML = IC.back + "<span>" + esc(T.back) + "</span>";
  mapWrap.insertBefore(back, stage);
  back.addEventListener("click", function () { deactivate(); });
  function showBack(on) { back.classList.toggle("is-show", !!on); }

  // Card (popup / bottom-sheet en móvil). SIN backdrop a propósito: en móvil la
  // capa oscura tapaba la card y el sidebar (el stage crea stacking context con
  // z-index:1, así que el z-index de la card no competía contra el backdrop) y
  // dejaba el mapa/lista intocables. Sin ella se ve el zoom y todo sigue usable.
  var card = document.createElement("div");
  card.className = "jf-card";
  card.setAttribute("role", "dialog");
  stage.appendChild(card);

  var activeId = null;
  var locked = false;
  var lockedId = null;   // tienda fijada (para revertir tras un preview por hover)
  var focusedState = null; // idx del estado con zoom activo (null = todo México)
  var pinFanSide = {};   // id -> 'above'|'below' (lado hacia afuera de la card en el abanico)
  var revertTimer = null; // debounce del revert al salir de un pin (evita parpadeo)

  // ---------- Cámara / zoom (anima el viewBox) ----------
  var cam = { x: 0, y: 0, w: W, h: H };
  var camAnim = null;
  var pinPos = {};   // id -> {x, y}
  var pinEls = {};   // id -> <g>
  var pinOffset = {};      // id -> {dx, dy}  desplazamiento del abanico (viewBox)
  var storesByState = {};  // stateIdx -> [{id, x, y}]
  var ZERO = { dx: 0, dy: 0 };

  // Compensación PARCIAL del tamaño de los pins al hacer zoom.
  // Compensarlos del todo (`cam.w / W`) los dejaba de tamaño constante en pantalla
  // mientras los dots del FONDO sí crecían con el zoom: a nivel de estado el dot
  // encendido medía ~19px y el pin ~10px, o sea la decoración terminaba siendo más
  // grande que las ubicaciones, que son lo único que importa. Con el exponente los
  // pins crecen, pero menos que los dots, y siguen mandando visualmente.
  // 1 = tamaño constante (lo de antes) · 0 = crecen igual que el mapa.
  var PIN_K = 0.35;
  function pinScale() { return Math.pow(cam.w / W, PIN_K); }
  function setPinScale() {
    var s = pinScale();
    for (var id in pinEls) {
      var p = pinPos[id], o = pinOffset[id] || ZERO;
      pinEls[id].setAttribute("transform", "translate(" + (p.x + o.dx) + "," + (p.y + o.dy) + ") scale(" + s + ")");
    }
    for (var ck in clusterEls) {
      var b = clusterEls[ck].bucket, co = pinOffset[ck] || ZERO;
      clusterEls[ck].el.setAttribute("transform", "translate(" + (b.x + co.dx) + "," + (b.y + co.dy) + ") scale(" + s + ")");
    }
  }
  function applyCam() {
    svg.setAttribute("viewBox", cam.x + " " + cam.y + " " + cam.w + " " + cam.h);
    setPinScale();
    if (activeId) positionCard(activeId);
  }
  function easeInOut(p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; }
  function zoomTo(target, dur) {
    if (reduce || !dur) {
      cam.x = target.x; cam.y = target.y; cam.w = target.w; cam.h = target.h;
      applyCam(); return;
    }
    if (camAnim) cancelAnimationFrame(camAnim);
    var from = { x: cam.x, y: cam.y, w: cam.w, h: cam.h }, t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), e = easeInOut(p);
      cam.x = from.x + (target.x - from.x) * e;
      cam.y = from.y + (target.y - from.y) * e;
      cam.w = from.w + (target.w - from.w) * e;
      cam.h = from.h + (target.h - from.h) * e;
      applyCam();
      if (p < 1) camAnim = requestAnimationFrame(step);
    }
    camAnim = requestAnimationFrame(step);
  }
  function fullView() { return { x: 0, y: 0, w: W, h: H }; }
  function stateTarget(idx) {
    var bb = stateBBox[idx];
    if (!bb) return fullView();
    var mx = (bb.minx + bb.maxx) / 2, my = (bb.miny + bb.maxy) / 2;
    var bw = (bb.maxx - bb.minx) * 1.4, bh = (bb.maxy - bb.miny) * 1.4;
    if (bw / bh < ASPECT) bw = bh * ASPECT; else bh = bw / ASPECT;
    // Tope de acercamiento. En pantallas chicas el mapa mide ~215-280px de alto:
    // con el tope de escritorio un estado chico (Yucatán) ocupaba media caja y la
    // otra mitad quedaba vacía. Ahí dejamos acercar más para que llene el cuadro.
    var minW = W * (mqMobile.matches ? 0.17 : 0.19);
    if (bw < minW) { bh *= minW / bw; bw = minW; }
    if (bw > W) { bw = W; bh = W / ASPECT; }
    var x = mx - bw / 2, y = my - bh / 2;
    // El estado va SIEMPRE centrado: no se clampa contra los bordes del mapa.
    // Con el clamp, un estado pegado a la costa (Yucatán) se recorría hasta el borde
    // este y todo el vacío quedaba de un solo lado — 338px libres a la izquierda
    // contra 199 a la derecha, que se lee como "roto". Fuera del mapa no hay nada
    // dibujado, así que un margen simétrico se lee como encuadre intencional.
    // Solo se evita que la cámara se vaya tan lejos que el estado salga de cuadro.
    var slackX = bw / 2, slackY = bh / 2;
    x = Math.max(-slackX, Math.min(x, W - bw + slackX));
    y = Math.max(-slackY, Math.min(y, H - bh + slackY));
    return { x: x, y: y, w: bw, h: bh };
  }

  // ---------- Abanico de pins encimados (mismo punto en el mapa) ----------
  // Al acercar un estado, los pins que caen casi en el mismo lugar se separan en
  // círculo con una líneita a su ubicación real, para poder tocar cada uno.
  function clearFan() {
    pinOffset = {};
    pinFanSide = {};
    while (gConnectors.firstChild) gConnectors.removeChild(gConnectors.firstChild);
    setPinScale();
  }
  // Marcadores dibujados de un estado: los pins sueltos + una entrada por cada
  // ciudad que se esté mostrando como burbuja.
  function markersOfState(stateIdx) {
    var out = (storesByState[stateIdx] || []).filter(function (pt) { return pinVisible(pt.id); })
      .map(function (pt) { return { id: pt.id, x: pt.x, y: pt.y }; });
    for (var k in clusterEls) {
      var b = clusterEls[k].bucket;
      if (b.city.stateIdx !== stateIdx) continue;
      out.push({ id: k, x: b.x, y: b.y });
    }
    return out;
  }

  function computeFan(stateIdx, camv) {
    clearFan();
    // Solo los pins VISIBLES: si el filtro oculta a la mitad, el abanico no debe
    // seguir separando huecos (dejaba conectores apuntando a pins invisibles).
    // Sobre MARCADORES, no sobre puntos: una burbuja también es un marcador y también
    // se encima. Medido con coordenadas reales: Mérida y Umán están a 18 km, que a
    // este zoom son 19px, y la burbuja mide ~54px — sin esto se montan una sobre otra.
    var list = markersOfState(stateIdx);
    if (list.length < 2) return;
    var sr = stage.getBoundingClientRect();
    var srW = sr.width || 1, srH = sr.height || 1;
    var kx = camv.w / srW, ky = camv.h / srH; // viewBox por px de pantalla
    function screen(pt) { return { sx: (pt.x - camv.x) / camv.w * srW, sy: (pt.y - camv.y) / camv.h * srH }; }
    // ⚠ El umbral tiene que ser MAYOR que el diámetro del marcador dibujado (~49px
    // la burbuja). Con 42px había marcadores que se tocaban sin llegar a agruparse:
    // no los separaba nadie y quedaban encimados.
    var THRESH = 58, groups = [];
    list.forEach(function (pt) {
      var s = screen(pt), g = null;
      for (var i = 0; i < groups.length; i++) {
        if (Math.hypot(s.sx - groups[i].cx, s.sy - groups[i].cy) < THRESH) { g = groups[i]; break; }
      }
      if (!g) { g = { members: [], cx: s.sx, cy: s.sy }; groups.push(g); }
      g.members.push({ pt: pt, s: s });
      g.cx = g.members.reduce(function (a, m) { return a + m.s.sx; }, 0) / g.members.length;
      g.cy = g.members.reduce(function (a, m) { return a + m.s.sy; }, 0) / g.members.length;
    });
    groups.forEach(function (g) {
      if (g.members.length < 2) return;
      var nn = g.members.length, R = 20 + 7 * nn; // radio en px de pantalla
      // Layout FIJO (no depende de la selección) -> el hover no mueve los pins.
      // Si el cúmulo está en la mitad alta del mapa, orientamos para que la mayoría
      // de las cards abran hacia abajo (donde hay más espacio).
      var startAng = (g.cy < srH * 0.5) ? Math.PI / 6 : (Math.PI + Math.PI / 6);
      g.members.forEach(function (m, i) {
        var ang = startAng + i * 2 * Math.PI / nn;
        var tsx = g.cx + R * Math.cos(ang), tsy = g.cy + R * Math.sin(ang);
        var dx = (tsx - m.s.sx) * kx, dy = (tsy - m.s.sy) * ky;
        pinOffset[m.pt.id] = { dx: dx, dy: dy };
        pinFanSide[m.pt.id] = Math.sin(ang) >= 0 ? "below" : "above"; // card hacia afuera del cúmulo
        var ln = document.createElementNS(SVGNS, "line");
        ln.setAttribute("class", "jf-connector");
        ln.setAttribute("x1", m.pt.x); ln.setAttribute("y1", m.pt.y);
        ln.setAttribute("x2", m.pt.x + dx); ln.setAttribute("y2", m.pt.y + dy);
        ln.setAttribute("vector-effect", "non-scaling-stroke");
        gConnectors.appendChild(ln);
      });
    });
    setPinScale();
  }

  // ---------- Encender estado ----------
  var litState = null;
  function lightState(idx) {
    if (litState === idx) return;
    unlight();
    var arr = dotsByState[idx] || [];
    for (var i2 = 0; i2 < arr.length; i2++) arr[i2].classList.add("is-lit");
    litState = idx;
  }
  function unlight() {
    if (litState === null) return;
    var arr = dotsByState[litState] || [];
    for (var i3 = 0; i3 < arr.length; i3++) arr[i3].classList.remove("is-lit");
    litState = null;
  }

  // ---------- Card ----------
  function positionCard(id) {
    if (mqMobile.matches) {
      // bottom-sheet: la posición la maneja el CSS
      card.style.left = ""; card.style.top = "";
      card.classList.remove("is-above", "is-below", "is-corner");
      return;
    }
    var pinEl = pinEls[id];
    if (!pinEl) return;
    var pr = pinEl.getBoundingClientRect(), sr = stage.getBoundingClientRect();

    // Con un estado enfocado la card se va a una ESQUINA en vez de anclarse al pin.
    // Anclada tapaba ~40% del estado y no hay posición anclada que lo evite: con el
    // estado centrado, los huecos que quedan a los lados son más angostos que la card.
    if (focusedState !== null) { placeCorner(sr); return; }
    card.classList.remove("is-corner");
    var lx = pr.left + pr.width / 2 - sr.left;
    var ty = pr.top + pr.height / 2 - sr.top;
    var cw = card.offsetWidth || 250, ch = card.offsetHeight || 200;
    var half = cw / 2, m = 8;

    // Horizontal: clampar el centro de la card dentro del mapa
    var left0 = Math.max(half + m, Math.min(lx, sr.width - half - m));
    card.style.left = left0 + "px";
    // La flechita apunta al pin real, no al centro de la card
    var ax = Math.max(14, Math.min(cw - 14, lx - left0 + half));
    card.style.setProperty("--arrow-x", ax + "px");

    // Vertical: en el abanico cada pin abre su card "hacia afuera" del cúmulo;
    // si no, se voltea según el espacio. Fallback: si el lado elegido se sale del
    // viewport, usar el opuesto.
    var below = pinFanSide[id] ? (pinFanSide[id] === "below") : (ty < (ch + 22));
    var vpY = sr.top + ty; // Y del pin en el viewport
    if (!below && vpY - ch - 22 < 4) below = true;
    else if (below && vpY + ch + 22 > window.innerHeight - 4) below = false;
    card.classList.toggle("is-below", below);
    card.classList.toggle("is-above", !below);
    card.style.top = ty + "px";
  }
  // Coloca la card en la esquina del mapa que menos tape al estado enfocado.
  // Se prueban las 4 y gana la de menor superposición; en empate manda el orden de
  // preferencia (abajo primero, y arriba-izquierda al final porque ahí vive el
  // botón "Ver todo México").
  function placeCorner(sr) {
    card.classList.remove("is-above", "is-below");
    card.classList.add("is-corner");
    var cw = card.offsetWidth || 250, ch = card.offsetHeight || 210, m = 10;
    var bb = stateBBox[focusedState], area = null;
    if (bb) {
      area = {
        x0: (bb.minx - cam.x) / cam.w * sr.width, x1: (bb.maxx - cam.x) / cam.w * sr.width,
        y0: (bb.miny - cam.y) / cam.h * sr.height, y1: (bb.maxy - cam.y) / cam.h * sr.height
      };
    }
    var cands = [
      { x: m, y: sr.height - ch - m },
      { x: sr.width - cw - m, y: sr.height - ch - m },
      { x: sr.width - cw - m, y: m },
      { x: m, y: m }
    ];
    var best = cands[0], bestOv = Infinity;
    cands.forEach(function (c) {
      var ov = 0;
      if (area) {
        var ox = Math.max(0, Math.min(area.x1, c.x + cw) - Math.max(area.x0, c.x));
        var oy = Math.max(0, Math.min(area.y1, c.y + ch) - Math.max(area.y0, c.y));
        ov = ox * oy;
      }
      if (ov < bestOv - 1) { bestOv = ov; best = c; }
    });
    card.style.left = Math.round(Math.max(m, best.x)) + "px";
    card.style.top = Math.round(Math.max(m, best.y)) + "px";
  }

  function buildCardContent(t) {
    var contact = "";
    if (t.telefono) contact += '<a class="jf-card__link" href="tel:+' + digits(t.telefono) + '">' + IC.phone + "<span>" + esc(t.telefono) + "</span></a>";
    if (t.whatsapp) contact += '<a class="jf-card__link" href="https://wa.me/' + digits(t.whatsapp) + '" target="_blank" rel="noopener">' + IC.wa + "<span>WhatsApp</span></a>";
    var tipoTag = '<span class="jf-card__type' + (esDist(t) ? " is-dist" : "") + '">' +
      esc(esDist(t) ? T.typeDistOne : T.typeStoreOne) + "</span>";
    card.innerHTML =
      '<button class="jf-card__close" aria-label="' + esc(T.close) + '">&times;</button>' +
      '<div class="jf-card__badges">' +
        '<div class="jf-card__badge">' + IC.pin + "<span>" + esc(t.estado) + "</span></div>" +
        tipoTag +
      "</div>" +
      '<h4 class="jf-card__name">' + esc(t.nombre) + "</h4>" +
      '<p class="jf-card__addr">' + esc(t.direccion) + "<br>" + esc(t.ciudad) + ", " + esc(t.estado) + "</p>" +
      (contact ? '<div class="jf-card__row">' + contact + "</div>" : "") +
      '<a class="jf-card__cta" href="' + esc(mapsUrl(t)) + '" target="_blank" rel="noopener">' + IC.route + esc(T.directions) + "</a>";
    card.querySelector(".jf-card__close").addEventListener("click", function () { deactivate(); });
  }

  function setActiveHighlight(id) {
    Array.prototype.forEach.call(gPins.children, function (g) {
      g.classList.toggle("is-active", g.getAttribute("data-id") === id);
    });
    Array.prototype.forEach.call(root.querySelectorAll("[data-store]"), function (el) {
      el.classList.toggle("is-active", el.getAttribute("data-store") === id);
    });
  }

  // Actualiza SOLO la card mostrada (contenido + resaltado + posición), sin tocar
  // el zoom ni el abanico. Se usa para el preview por hover cuando ya hay zoom.
  function renderCard(id) {
    var t = TIENDAS.filter(function (x) { return x.id === id; })[0];
    if (!t) return;
    activeId = id;
    buildCardContent(t);
    setActiveHighlight(id);
    positionCard(id);
    card.classList.add("is-open");
    // Preview (no es la tienda fijada) -> la card no intercepta el mouse (evita flicker)
    card.classList.toggle("is-preview", activeId !== lockedId);
  }

  // ---------- Enfocar un estado (zoom + dots en pastel + abanico) ----------
  // Se usa tanto al elegir una tienda como al tocar un estado en el sidebar.
  function focusState(sidx, dur) {
    if (sidx === undefined || sidx === null || sidx < 0) return null;
    focusedState = sidx;
    lightState(sidx);
    var target = stateTarget(sidx);
    zoomTo(target, dur === undefined ? 640 : dur);
    computeFan(sidx, target); // separa los pins encimados de ese estado
    showBack(true);
    syncSide();
    return target;
  }

  function activate(id, lock) {
    var t = TIENDAS.filter(function (x) { return x.id === id; })[0];
    if (!t) return;
    activeId = id;
    var sidx = stateIdxOf(t);
    buildCardContent(t);
    setActiveHighlight(id);
    if (lock && sidx >= 0) {
      locked = true;
      lockedId = id;
      focusState(sidx, 640);
      positionCard(id);       // re-ancla la card al pin ya desplazado por el abanico
    } else {
      locked = false;
      lockedId = null;
      if (focusedState === null) { lightState(sidx); clearFan(); }
      positionCard(id);
    }
    card.classList.add("is-open");
    card.classList.toggle("is-preview", activeId !== lockedId);
  }

  // Cierra SOLO la card, sin soltar el zoom del estado (estado enfocado desde el sidebar)
  function hideCard() {
    activeId = null;
    card.classList.remove("is-open", "is-preview");
    setActiveHighlight(null);
  }

  function deactivate() {
    activeId = null;
    locked = false;
    lockedId = null;
    focusedState = null;
    card.classList.remove("is-open");
    unlight();
    clearFan();
    setActiveHighlight(null);
    showBack(false);
    syncSide();
    if (cam.w !== W || cam.x !== 0 || cam.y !== 0) zoomTo(fullView(), 560);
  }

  // ---------- Crear pins ----------
  TIENDAS.forEach(function (t, idx) {
    var x = px(t.lng), y = py(t.lat);
    pinPos[t.id] = { x: x, y: y };
    var sidx0 = stateIdxOf(t);
    (storesByState[sidx0] || (storesByState[sidx0] = [])).push({ id: t.id, x: x, y: y });

    var dist = esDist(t);
    var g = document.createElementNS(SVGNS, "g");
    // El tipo se lee por COLOR y por FORMA (el aro de abajo). Solo por color no basta:
    // los dos rosas se diferencian sobre todo por luminosidad y hay quien no los distingue.
    g.setAttribute("class", "jf-pin" + (dist ? " jf-pin--dist" : ""));
    g.setAttribute("data-id", t.id);
    g.setAttribute("data-tipo", tipoOf(t));
    g.setAttribute("tabindex", "0");
    g.setAttribute("role", "button");
    g.setAttribute("aria-label",
      (dist ? T.typeDistOne : T.typeStoreOne) + ": " + t.nombre + " — " + t.ciudad + ", " + t.estado);
    g.setAttribute("transform", "translate(" + x + "," + y + ") scale(1)");
    g.style.setProperty("--pd", (820 + idx * 90) + "ms");

    var pulse = document.createElementNS(SVGNS, "circle");
    pulse.setAttribute("class", "jf-pin-pulse");
    pulse.setAttribute("r", "4");
    pulse.style.animationDelay = (Math.abs(hashStr(t.id)) % 2000) / 1000 + "s";

    var core = document.createElementNS(SVGNS, "circle");
    core.setAttribute("class", "jf-pin-core");
    core.setAttribute("r", "5");

    var dot = document.createElementNS(SVGNS, "circle");
    dot.setAttribute("class", "jf-pin-dot");
    dot.setAttribute("r", "1.8");

    var hit = document.createElementNS(SVGNS, "circle");
    hit.setAttribute("class", "jf-pin-hit");
    hit.setAttribute("r", "13");

    g.appendChild(pulse); g.appendChild(core);
    // Aro exterior: silueta distinta para la distribuidora, no solo otro tono de rosa
    if (dist) {
      var ring = document.createElementNS(SVGNS, "circle");
      ring.setAttribute("class", "jf-pin-ring");
      ring.setAttribute("r", "7.6");
      g.appendChild(ring);
    }
    g.appendChild(dot); g.appendChild(hit);
    gPins.appendChild(g);
    pinEls[t.id] = g;

    g.addEventListener("pointerenter", function (e) {
      if (e.pointerType === "touch") return;
      clearTimeout(revertTimer);
      if (focusedState === null) {
        activate(t.id, false); // vista nacional: preview + enciende estado
      } else if (stateIdxOf(t) === focusedState && t.id !== activeId) {
        renderCard(t.id);      // ya con zoom: preview de otra tienda del mismo estado
      }
    });
    g.addEventListener("pointerleave", function () {
      if (focusedState === null) {
        if (activeId === t.id) deactivate();
        return;
      }
      if (activeId !== t.id || lockedId === t.id) return;
      // debounce: si el mouse pasa a otro pin no parpadea; si sale, vuelve a la
      // tienda fijada (o cierra la card si el estado se enfocó desde el sidebar)
      clearTimeout(revertTimer);
      revertTimer = setTimeout(function () {
        if (focusedState === null) return;
        if (lockedId) { if (activeId !== lockedId) renderCard(lockedId); }
        else hideCard();
      }, 140);
    });
    g.addEventListener("click", function () {
      if (locked && lockedId === t.id) deactivate();
      else activate(t.id, true);
    });
    g.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); activate(t.id, true); }
      if (e.key === "Escape") deactivate();
    });
  });

  applyCam(); // normaliza viewBox + escala de pins

  // ---------- Sidebar: ubicaciones agrupadas por estado ----------
  // Un grupo abierto == su estado enfocado en el mapa. Sin estado enfocado se
  // abren todos (se ve el catálogo completo de un vistazo).
  var sideEl = root.querySelector("[data-side]");
  var sideList = root.querySelector("[data-side-list]");
  var sideReset = root.querySelector("[data-side-reset]");
  var mqSide = window.matchMedia("(min-width: 900px)"); // sidebar junto al mapa
  var GROUPS = [];
  var groupEls = {};

  (function buildGroups() {
    var byKey = {};
    TIENDAS.forEach(function (t) {
      var key = normStr(t.estado);
      if (!byKey[key]) {
        var idx = stateIdxOf(t);
        byKey[key] = {
          key: key,
          idx: idx,
          // nombre canónico cuando hace match (CDMX -> Ciudad de México)
          label: idx >= 0 ? proj.states[idx] : (t.estado || "Sin estado"),
          stores: []
        };
        GROUPS.push(byKey[key]);
      }
      byKey[key].stores.push(t);
    });
    GROUPS.sort(function (a, b) { return a.label.localeCompare(b.label, "es"); });
    GROUPS.forEach(function (g) {
      g.stores.sort(function (a, b) { return String(a.nombre).localeCompare(String(b.nombre), "es"); });
      // Sub-agrupación por ciudad: la usan el mapa (burbujas) y el listado
      var byCity = {};
      g.cities = [];
      g.stores.forEach(function (t) {
        var ck = normStr(t.ciudad) || "sin-ciudad";
        if (!byCity[ck]) {
          byCity[ck] = { key: g.key + "|" + ck, label: t.ciudad || "—", stateIdx: g.idx, stores: [] };
          g.cities.push(byCity[ck]);
        }
        byCity[ck].stores.push(t);
        cityOf[t.id] = byCity[ck];
      });
      g.cities.sort(function (a, b) { return a.label.localeCompare(b.label, "es"); });
    });
  })();

  // ---------- Burbujas de ciudad en el mapa ----------
  // Solo se crean donde PUEDEN hacer falta: el filtro únicamente baja el conteo,
  // nunca lo sube, así que una ciudad que no llega al umbral jamás necesita burbuja.
  // Se agrupa por CIUDAD + TIPO, no solo por ciudad: si una ciudad tiene 8 tiendas y 6
  // distribuidoras salen DOS burbujas, no una de 14. Así la regla vale igual para
  // distribuidoras y de paso se ve la composición de la ciudad de un vistazo.
  GROUPS.forEach(function (g) {
    g.cities.forEach(function (c) {
      var sx = 0, sy = 0;
      c.stores.forEach(function (t) { sx += pinPos[t.id].x; sy += pinPos[t.id].y; });
      c.x = sx / c.stores.length; c.y = sy / c.stores.length;

      var porTipo = {};
      c.stores.forEach(function (t) { (porTipo[tipoOf(t)] || (porTipo[tipoOf(t)] = [])).push(t); });
      Object.keys(porTipo).forEach(function (tipo) {
        var lista = porTipo[tipo];
        var b = { key: c.key + "|" + tipo, city: c, tipo: tipo, stores: lista, x: 0, y: 0 };
        var bx = 0, by = 0;
        lista.forEach(function (t) { bx += pinPos[t.id].x; by += pinPos[t.id].y; bucketOf[t.id] = b; });
        b.x = bx / lista.length; b.y = by / lista.length;
        if (lista.length < CLUSTER_MIN) return;

        var esD = tipo === DIST;
        var el = document.createElementNS(SVGNS, "g");
        el.setAttribute("class", "jf-cluster" + (esD ? " is-dist" : ""));
        el.setAttribute("data-city", c.key);
        el.setAttribute("data-tipo", tipo);
        el.setAttribute("tabindex", "0");
        el.setAttribute("role", "button");
        el.setAttribute("aria-label",
          (esD ? T.typeDist : T.typeStore) + " — " + c.label + ": " + lista.length);
        var circ = document.createElementNS(SVGNS, "circle");
        circ.setAttribute("class", "jf-cluster-core");
        circ.setAttribute("r", "7.2");
        el.appendChild(circ);
        // Mismo criterio que los pins: el tipo NO puede depender solo del color
        if (esD) {
          var ring = document.createElementNS(SVGNS, "circle");
          ring.setAttribute("class", "jf-cluster-ring");
          ring.setAttribute("r", "9.6");
          el.appendChild(ring);
        }
        var txt = document.createElementNS(SVGNS, "text");
        txt.setAttribute("class", "jf-cluster-n");
        txt.setAttribute("text-anchor", "middle");
        txt.setAttribute("dy", "0.36em");
        txt.textContent = lista.length;
        el.appendChild(txt);
        gPins.appendChild(el);
        clusterEls[b.key] = { el: el, bucket: b };
        el.addEventListener("click", function () { onCityClick(c); });
        el.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onCityClick(c); }
          if (e.key === "Escape") deactivate();
        });
      });
    });
  });

  // Clic en una burbuja -> enfoca su estado y abre ESA ciudad en el listado,
  // que es donde hay espacio para scrollear una lista larga.
  function onCityClick(c) {
    hideCard();
    if (focusedState !== c.stateIdx) focusState(c.stateIdx, 640);
    openCity(c.key);
    scrollMapIntoView();
  }
  function syncCities() {
    for (var k in cityEls) {
      var on = k === openCityKey;
      cityEls[k].el.classList.toggle("is-open", on);
      cityEls[k].head.setAttribute("aria-expanded", on ? "true" : "false");
    }
    for (var ck in clusterEls) clusterEls[ck].el.classList.toggle("is-active", ck === openCityKey);
  }
  function toggleCity(key) { openCityKey = (openCityKey === key ? null : key); syncCities(); }
  function openCity(key) {
    openCityKey = key;
    syncCities();
    var ce = cityEls[key];
    if (ce && sideList) sideList.scrollTop = Math.max(0, ce.el.offsetTop - 6);
  }
  // Las burbujas siempre están; el filtro solo las apaga a gris.
  function syncClusters() {
    for (var k in clusterEls) {
      clusterEls[k].el.classList.toggle("is-muted", !tipoActivo(clusterEls[k].bucket.tipo));
    }
  }

  function groupByIdx(idx) {
    for (var gi = 0; gi < GROUPS.length; gi++) if (GROUPS[gi].idx === idx) return GROUPS[gi];
    return null;
  }

  function syncSide() {
    for (var k in groupEls) {
      var ge = groupEls[k];
      var isFocus = ge.group.idx >= 0 && ge.group.idx === focusedState;
      var isOpen = focusedState === null || isFocus;
      ge.el.classList.toggle("is-focus", isFocus);
      ge.el.classList.toggle("is-open", isOpen);
      ge.head.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }
    if (sideReset) sideReset.hidden = focusedState === null;
    // deja a la vista el grupo enfocado dentro del scroll del sidebar
    if (focusedState !== null && sideList) {
      var g = groupByIdx(focusedState);
      if (g && groupEls[g.key]) sideList.scrollTop = Math.max(0, groupEls[g.key].el.offsetTop - 6);
    }
  }

  function scrollMapIntoView() {
    // en desktop el mapa ya está junto al sidebar: no hace falta mover la página
    if (mqSide.matches) return;
    if (!mqMobile.matches) {
      stage.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
      return;
    }
    // Con bottom-sheet: subimos el mapa hasta arriba para que la card no lo tape
    // (centrarlo lo dejaba justo detrás del sheet). Descontamos lo que el tema tenga
    // pegado arriba: con margen fijo de 16px el mapa —y el botón "Ver todo México"—
    // quedaban DEBAJO del header sticky de jousfit.com (64px). No se puede dar por
    // hecho en local: el index.html de preview no tiene header.
    var top = window.scrollY + stage.getBoundingClientRect().top - (stickyTop() + 16);
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? "auto" : "smooth" });
  }

  // Alto de lo que el tema fija/pega en el borde superior (header sticky, barra de
  // anuncios). Se mide en vivo en vez de hardcodear selectores de Focal, para que
  // siga funcionando si cambia el tema.
  function stickyTop() {
    var off = 0;
    try {
      var els = document.elementsFromPoint(Math.round(window.innerWidth / 2), 2);
      for (var i = 0; i < els.length; i++) {
        var cs = window.getComputedStyle(els[i]);
        if (cs.position !== "fixed" && cs.position !== "sticky") continue;
        var r = els[i].getBoundingClientRect();
        if (r.top <= 4 && r.height > 0 && r.height < 220) off = Math.max(off, r.bottom);
      }
    } catch (e) { /* elementsFromPoint no disponible -> sin offset */ }
    return off;
  }

  function storeBtn(t) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "jf-store";
    btn.setAttribute("data-store", t.id);
    var dist = esDist(t);
    btn.setAttribute("data-tipo", tipoOf(t));
    btn.innerHTML =
      '<p class="jf-store__name">' + esc(t.nombre) + "</p>" +
      '<p class="jf-store__meta">' +
        '<span class="jf-store__dot"></span>' + esc(t.ciudad) +
        '<span class="jf-store__type' + (dist ? " is-dist" : "") + '">' +
          esc(dist ? T.typeDistOne : T.typeStoreOne) +
        "</span>" +
      "</p>";
    btn.addEventListener("click", function () {
      activate(t.id, true);
      scrollMapIntoView();
    });
    return btn;
  }

  function onGroupClick(g) {
    // clic en el estado ya enfocado (o en uno sin match) -> volver a todo México
    if (g.idx < 0 || g.idx === focusedState) { deactivate(); return; }
    hideCard();
    focusState(g.idx, 640);
    scrollMapIntoView();
  }

  if (sideList) {
    if (!GROUPS.length) {
      sideList.innerHTML = '<p class="jf-side__empty">' + esc(T.empty) + '</p>';
    }
    GROUPS.forEach(function (g) {
      var wrap = document.createElement("div");
      wrap.className = "jf-side__group";

      var head = document.createElement("button");
      head.type = "button";
      head.className = "jf-side__toggle";
      head.setAttribute("aria-expanded", "true");
      head.innerHTML =
        '<span class="jf-side__pin"></span>' +
        '<span class="jf-side__name">' + esc(g.label) + "</span>" +
        '<span class="jf-side__count">' + g.stores.length + "</span>" +
        IC.chev;
      head.addEventListener("click", function () { onGroupClick(g); });

      var box = document.createElement("div");
      box.className = "jf-side__stores";
      if (g.stores.length >= CLUSTER_MIN) {
        // Con muchos puntos el listado agrupa por ciudad: un estado con 40 no puede
        // ser una lista plana de 40 renglones. Una ciudad con UNA sola ubicación se
        // muestra directo, sin acordeón (sería un desplegable de un solo elemento).
        g.cities.forEach(function (c) {
          if (c.stores.length < 2) { box.appendChild(storeBtn(c.stores[0])); return; }
          var cw = document.createElement("div");
          cw.className = "jf-city";
          var ch = document.createElement("button");
          ch.type = "button";
          ch.className = "jf-city__toggle";
          ch.setAttribute("aria-expanded", "false");
          ch.innerHTML =
            '<span class="jf-city__name">' + esc(c.label) + "</span>" +
            '<span class="jf-city__count">' + c.stores.length + "</span>" + IC.chev;
          ch.addEventListener("click", function () { toggleCity(c.key); });
          var cb = document.createElement("div");
          cb.className = "jf-city__stores";
          c.stores.forEach(function (t) { cb.appendChild(storeBtn(t)); });
          cw.appendChild(ch); cw.appendChild(cb);
          box.appendChild(cw);
          cityEls[c.key] = { el: cw, head: ch, city: c };
        });
      } else {
        g.stores.forEach(function (t) { box.appendChild(storeBtn(t)); });
      }

      wrap.appendChild(head);
      wrap.appendChild(box);
      sideList.appendChild(wrap);
      groupEls[g.key] = { el: wrap, head: head, group: g };
    });
    syncSide();
  }
  if (sideReset) sideReset.addEventListener("click", function () { deactivate(); });

  // ---------- Filtro por tipo: 3 botones ARRIBA del mapa ----------
  // Van antes del mapa a propósito. Dentro del sidebar (donde estaban) no cabían en
  // una línea en NINGÚN ancho —333px de botones en 264px de sidebar— y en móvil el
  // sidebar va debajo del mapa, así que el filtro aparecía después de lo que filtra.
  // Se arma desde el JS —igual que el listado— para no mantener el mismo markup en
  // el index.html de preview y en la sección .liquid.
  var N_TIENDA = TIENDAS.filter(function (t) { return !esDist(t); }).length;
  var N_DIST = TIENDAS.filter(esDist).length;
  var chipEls = {};
  var mapLayout = root.querySelector(".jf-map-layout");

  // Sin distribuidoras cargadas no tiene sentido ofrecer el filtro: sería un botón
  // que siempre da vacío. Aparece solo cuando de verdad hay los dos tipos.
  if (mapLayout && N_DIST > 0 && N_TIENDA > 0) {
    var filters = document.createElement("div");
    filters.className = "jf-filters jf-anim";
    filters.style.setProperty("--d", "360ms");
    filters.setAttribute("role", "group");
    filters.setAttribute("aria-label", T.filterAll + " / " + T.typeStore + " / " + T.typeDist);
    // Sin conteo dentro del botón: los números ya son el titular de la sección
    // (la fila de contadores), y repetirlos aquí duplicaba el dato.
    [
      { key: "todas", label: T.filterAll },
      { key: "tienda", label: T.typeStore },
      { key: DIST, label: T.typeDist }
    ].forEach(function (c) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "jf-filter" + (c.key === activeType ? " is-on" : "");
      b.setAttribute("data-chip", c.key);
      b.setAttribute("aria-pressed", c.key === activeType ? "true" : "false");
      b.textContent = c.label;
      b.addEventListener("click", function () { setType(c.key); });
      filters.appendChild(b);
      chipEls[c.key] = b;
    });
    mapLayout.parentNode.insertBefore(filters, mapLayout);
  }

  function setType(key) {
    if (activeType === key) return;
    activeType = key;
    for (var k in chipEls) {
      var on = k === key;
      chipEls[k].classList.toggle("is-on", on);
      chipEls[k].setAttribute("aria-pressed", on ? "true" : "false");
    }
    applyFilter();
  }

  function applyFilter() {
    // 0. Primero las burbujas: definen qué pins quedan ocultos por estar agrupados
    syncClusters();
    // 1. Pins del mapa: ocultos SOLO si los representa una burbuja; el filtro los apaga
    for (var id in pinEls) {
      pinEls[id].classList.toggle("is-hidden", !pinVisible(id));
      pinEls[id].classList.toggle("is-muted", apagado(id));
    }

    // 2. Listado: items, conteo por estado y grupos que se quedan vacíos
    var quedaronEstados = {};
    for (var key in groupEls) {
      var ge = groupEls[key];
      var vis = ge.group.stores.filter(pasaFiltro);
      Array.prototype.forEach.call(ge.el.querySelectorAll("[data-store]"), function (btn) {
        btn.hidden = !idVisible(btn.getAttribute("data-store"));
      });
      var cnt = ge.head.querySelector(".jf-side__count");
      if (cnt) cnt.textContent = vis.length;
      ge.el.hidden = vis.length === 0;
      // ciudades: recuentan y desaparecen si el filtro las deja vacías
      ge.group.cities.forEach(function (c) {
        var ce = cityEls[c.key];
        if (!ce) return;
        var n = c.stores.filter(pasaFiltro).length;
        ce.el.hidden = n === 0;
        var cn = ce.head.querySelector(".jf-city__count");
        if (cn) cn.textContent = n;
      });
      if (vis.length) quedaronEstados[ge.group.idx] = true;
    }

    // 3. Si lo que estaba enfocado/abierto ya no existe bajo este filtro, soltarlo.
    //    focusedState es la fuente de verdad de la interacción: hay que pasar por
    //    deactivate()/hideCard() y no tocar el zoom por fuera.
    if (focusedState !== null && !quedaronEstados[focusedState]) { deactivate(); return; }
    if (activeId && !idVisible(activeId)) {
      if (lockedId && !idVisible(lockedId)) { deactivate(); return; }
      hideCard();
    }
    // 4. El abanico depende de qué pins quedan visibles
    if (focusedState !== null) computeFan(focusedState, cam);
  }

  applyFilter();  // estado inicial: decide burbujas vs pins sueltos

  // ---------- Stats (contador animado) ----------
  var estados = {};
  TIENDAS.forEach(function (t) { estados[t.estado] = true; });
  var elT = root.querySelector("[data-stat-tiendas]");
  var elE = root.querySelector("[data-stat-estados]");
  var elD = root.querySelector("[data-stat-distribuidoras]");
  // El contador de distribuidoras se oculta si no hay ninguna cargada (no queremos un "0"
  // en el encabezado mientras el programa arranca). Los contadores son el titular de la
  // sección, así que NO cambian con el filtro de los chips.
  if (elD && elD.closest(".jf-stat")) elD.closest(".jf-stat").hidden = N_DIST === 0;
  function countUp(el, to) {
    if (!el) return;
    if (reduce || to === 0) { el.textContent = to; return; }
    var t0 = null, dur = 900;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      el.textContent = Math.round(easeInOut(p) * to);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // ---------- Reveal al entrar en viewport ----------
  var revealed = false;
  function reveal() {
    if (revealed) return;
    revealed = true;
    root.classList.add("is-revealed");
    countUp(elT, N_TIENDA);
    countUp(elD, N_DIST);
    countUp(elE, Object.keys(estados).length);
  }
  if (reduce || !("IntersectionObserver" in window)) {
    reveal();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { reveal(); io.disconnect(); } });
    }, { threshold: 0.15 });
    io.observe(root);
  }

  // ---------- Cerrar fuera / Escape / breakpoint ----------
  document.addEventListener("click", function (e) {
    if (focusedState === null && !activeId) return;
    if (stage.contains(e.target) || isStoreBtn(e.target)) return;
    if (e.target === back || back.contains(e.target)) return;
    if (sideEl && sideEl.contains(e.target)) return; // el sidebar maneja su propio clic
    deactivate();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") deactivate(); });
  mqMobile.addEventListener("change", function () { if (activeId) positionCard(activeId); });
  window.addEventListener("resize", function () { if (activeId) positionCard(activeId); });

  // ---------- helpers ----------
  function isStoreBtn(el) { return el && el.closest && el.closest("[data-store]"); }
  function hashStr(s) { var h = 0; for (var i = 0; i < s.length; i++) { h = (h << 5) - h + s.charCodeAt(i); h |= 0; } return h; }
})();
